// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l8tA","textarea":"styles_textarea__yWfAg"};